import styled from 'styled-components'
import CheckBoxGroup from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInputSet'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import type { BigCategory, SmallCategory } from '@pc/components/Works/Panel/types'
import type { ChangeEvent, ChangeEventHandler } from 'react'

interface PropsType {
  selectedJobIds: string[]
  changeJobIds: (arg: string[]) => void
  bigCategory: BigCategory
  smallCategories: SmallCategory[]
}

const CheckBoxOccupationInputSet = styled(CheckBoxInputSet)`
  margin-right: 40px;
`

const OccupationControlGroup = styled(ControlGroup)`
  cursor: default;
  margin: 0 15px 15px;
`

const renderSmallCategoryCheckboxes = (smallCategories: SmallCategory[], selectedJobIds: string[], toggleCheckbox: ChangeEventHandler) => {
  return smallCategories.map((smallCategory) => {
    const smallCategoryId = `occupation-small-category-${smallCategory.id}`
    return (
      <CheckBoxOccupationInputSet key={smallCategory.id}>
        <CheckBoxInput
          type="checkbox"
          id={smallCategoryId}
          value={smallCategory.id}
          onChange={toggleCheckbox}
          checked={selectedJobIds.includes(String(smallCategory.id))}
        />
        <CheckBoxLabel htmlFor={smallCategoryId}>{smallCategory.attributes.name}</CheckBoxLabel>
      </CheckBoxOccupationInputSet>
    )
  })
}

const OccupationCheckboxes = (props: PropsType) => {
  const { bigCategory, smallCategories, selectedJobIds, changeJobIds } = props

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedJobIds = selectedJobIds.concat(value)
      changeJobIds(concatedJobIds)
      return
    }

    const filteredJobIds = selectedJobIds.filter((selectedJobId) => selectedJobId !== value)
    changeJobIds(filteredJobIds)
  }

  const toggleAllCheckbox = () => {
    const { smallCategories, selectedJobIds, changeJobIds } = props
    const jobIds: string[] = smallCategories.map((category) => category.id)

    if (isAllSelected()) {
      changeJobIds(selectedJobIds.filter((selectedJobId) => !jobIds.includes(selectedJobId)))
    } else {
      changeJobIds([...new Set([...selectedJobIds, ...jobIds])])
    }
  }

  const isAllSelected = () => {
    const { smallCategories, selectedJobIds } = props
    const jobIds = smallCategories.map((smallCategory) => smallCategory.id)
    return jobIds.every((jobId) => selectedJobIds.includes(jobId))
  }

  const bigCategoryId = `occupation-big-category-${bigCategory.id}`

  return (
    <OccupationControlGroup>
      <CheckBoxGroup>
        <CheckBoxInputSet>
          <CheckBoxInput type="checkbox" id={bigCategoryId} onChange={toggleAllCheckbox} checked={isAllSelected()} />
          <CheckBoxLabel htmlFor={bigCategoryId}>{bigCategory.attributes.name}全て</CheckBoxLabel>
        </CheckBoxInputSet>
      </CheckBoxGroup>
      <CheckBoxGroup>{renderSmallCategoryCheckboxes(smallCategories, selectedJobIds, toggleCheckbox)}</CheckBoxGroup>
    </OccupationControlGroup>
  )
}

export default OccupationCheckboxes
